import { AxiosRequestConfig } from 'axios';
import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

type FollowParams = {
    subjectId?: number | string;
    subjectType?: string;
    world?: string;
};

export const follow = (params: FollowParams = {}, anonymous = false, config?: AxiosRequestConfig) =>
    axios.post(anonymous ? API_URLS.SUBSCRIPTION.FOLLOW_ANONYMOUS : API_URLS.SUBSCRIPTION.FOLLOW, params, config);

export const unfollow = (params: FollowParams = {}, anonymous = false, config?: AxiosRequestConfig) =>
    axios.post(
        anonymous ? API_URLS.SUBSCRIPTION.UNFOLLOW_ANONYMOUS : API_URLS.SUBSCRIPTION.UNFOLLOW,
        params,
        config
    );
